import BlockModel from './block.model';

export default class UndoRedoBlockyModel {
	past: [] = [];
	present: BlockModel[] = [];
	future: [] = [];
}
